var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettlements = function SvgSettlements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.083 4.444H5.14v11.111h9.722V7.222h-2.778V4.444Zm-8.333-.7c0-.38.31-.689.694-.689h8.334l3.472 3.473v9.717a.695.695 0 0 1-.69.7H4.44a.695.695 0 0 1-.69-.69V3.745Z",
    fill: "#1D1737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.733 10.563V9.167h6.6v1.396h-6.6ZM6.667 13.063v-1.396h6.666v1.396H6.667Z",
    fill: "#1D1737"
  })));
};
export default SvgSettlements;